export default __webpack_public_path__ + "static/media/starOrange.71fe4d13.svg";